import React from 'react';
import { FiUsers } from 'react-icons/fi';
import { usePermissions } from '../context/PermissionsContext';
import ServicesCustomersPanel from '../components/services/ServicesCustomersPanel';
import { FadeIn } from '../components/motion';
import './Services.css';
import './Requisitions.css';

/**
 * Top-level Customers page — consulting client records for quotes/invoices.
 */
const Customers = () => {
  const { hasAnyPermission } = usePermissions();
  // Mirrors canManage/canView in backend/src/routes/customers.js.
  const canManage = hasAnyPermission(['service_customers_manage', 'service_manage']);
  const canView =
    hasAnyPermission([
      'tab_customers',
      'service_customers_view',
      'service_sales_view',
      'service_sales_manage',
    ]) || canManage;

  if (!canView) {
    return (
      <div className="customers-page list-page">
        <div className="error" role="alert">
          You do not have permission to view customers.
        </div>
      </div>
    );
  }

  return (
    <div className="customers-page list-page">
      <FadeIn className="page-header">
        <div className="page-header-text">
          <h1>
            <FiUsers aria-hidden /> Customers
          </h1>
          <p className="page-subtitle">
            Consulting client billing details and stakeholders for quotations and invoices.
          </p>
        </div>
      </FadeIn>
      <ServicesCustomersPanel canManage={canManage} showTitle={false} />
    </div>
  );
};

export default Customers;
